import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { WithdrawPayload } from '@monorepo/client-types';
import { Space } from '@monorepo/react-components';
import { PayoutSource } from '@monorepo/types';
import { notes, terms } from '../utils';

interface NotesAndTermsSectionProps {
  source: PayoutSource;
  form: UseFormReturn<WithdrawPayload>;
}

export const NotesAndTermsSection: React.FC<NotesAndTermsSectionProps> = ({
  source,
  form,
}) => {
  const paymentMethod = form.getValues('paymentOption');

  return (
    <Space direction="vertical" size="small" className="terms">
      {notes(source, paymentMethod)}
      {terms(source, form)}
    </Space>
  );
};
